import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { ConfirmationModal } from 'vdlib';
import Portlet from '../layout/Portlet';
import { getColumns } from './columns';
import PartiesListFilters from './PartiesListFilters';

import { Table } from 'antd';

const stringComparator = (value, filterValue) => {
  if (!value) return false;
  const stringValue = String(value).toLowerCase();
  const compareValue = String(filterValue).toLowerCase();
  return stringValue.indexOf(compareValue) > -1;
};

const PartiesList = ({
  enableDisableParty,
  fetchParties,
  filters,
  location,
  clearFilters,
  partiesData,
  partyTypes,
  regions,
  setFilter,
  submitting,
  user,
}) => {
  const [partyToToggle, setPartyToToggle] = React.useState(null);

  React.useEffect(() => {
    if (!submitting) fetchParties();
  }, [submitting]); //eslint-disable-line

  React.useEffect(() => {
    setPartyToToggle(null);
  }, [partiesData, setPartyToToggle]);

  const handleSubmit = React.useCallback(() => {
    enableDisableParty(partyToToggle.ID);
  }, [enableDisableParty, partyToToggle]);

  React.useEffect(() => {
    if (Array.isArray(filters) && filters.length > 0) {
      const { Value: filterLocation } =
        filters.find(f => f.Name === 'forLocation') || {};
      if (!filterLocation || filterLocation !== location.pathname) {
        if (!!filterLocation) clearFilters();
        setFilter('forLocation', location.pathname);
      }
    }
  }, []); // eslint-disable-line

  // actual auction data that will be sent to table
  const filteredParties = React.useMemo(() => {
    const filterFunc =
      Array.isArray(filters) && filters.length > 0
        ? party =>
            filters
              .filter(x => x.Name !== 'forLocation')
              .every(f => {
                if (!f.Name) return false;
                return stringComparator(party[f.Name], f.Value);
              })
        : item => item;

    return (partiesData || []).filter(filterFunc);
  }, [partiesData, filters]);

  const columnDefs = React.useMemo(() => {
    return getColumns(regions, partyTypes, setPartyToToggle);
  }, [regions, partyTypes, setPartyToToggle]);

  const columnsWidth = React.useMemo(
    () =>
      (columnDefs || []).reduce(
        (sum, columnDef) =>
          sum + (typeof columnDef.width === 'number' ? columnDef.width : 0),
        200
      ),
    [columnDefs]
  );

  return (
    <div>
      <h1 className="page-title">{I.t('PARTIES')}</h1>

      <Portlet bodyClassName="form-horizontal">
        <PartiesListFilters
          partyTypes={partyTypes}
          filters={filters}
          setFilter={setFilter}
          location={location}
        />

        <Table
          dataSource={filteredParties}
          columns={columnDefs}
          size="small"
          bordered={true}
          scroll={{
            x: columnsWidth,
          }}
        />
      </Portlet>
      <ConfirmationModal
        onHide={() => setPartyToToggle(null)}
        onReject={() => setPartyToToggle(null)}
        show={!!partyToToggle}
        title={I.t('ACTIVATE_DEACTIVATE')}
        onSubmit={handleSubmit}
        loading={submitting}
        promptText={
          partyToToggle && (
            <div className="note note-warning">
              {partyToToggle.IsInactive
                ? I.t('MODAL_QUESTION_PARTY_ACTIVATE')
                : I.t('MODAL_QUESTION_PARTY_DEACTIVATE')}
              <br />
              {I.t('ARE_YOU_SURE')}
            </div>
          )
        }
      />
    </div>
  );
};

export default PartiesList;
